var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamistLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.847,
    height: 25.331,
    viewBox: "0 0 128.847 25.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M240.685.029c-.084,0-.168,0-.252,0,.084,0,.168,0,.252,0M238.933,0c.058,0,.115.082.172.124l.009,0a.012.012,0,0,0,.009,0A13.382,13.382,0,0,1,241.668,2.6a13.45,13.45,0,0,1,1.5-.083l.155,0L241.776.074s-.009-.015-.013-.015L241.727,0Z",
    transform: "translate(-238.933 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -15.796,
    y1: 9.757,
    x2: -15.73,
    y2: 9.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c16aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd67a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M248.35,8.745a13.3,13.3,0,0,1,1.612,2.613c.14-.025.281-.046.423-.067l.722-.889h0l-1.1-1.738-.155,0a13.38,13.38,0,0,0-1.5.085",
    transform: "translate(-248.35 -8.66)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.131,
    y1: 8.457,
    x2: -26.026,
    y2: 8.457,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae4492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae4995"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M253.9,17.78c.045.1.089.193.132.291l.291-.36c-.141.021-.283.044-.423.069",
    transform: "translate(-253.899 -17.711)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -174.504,
    y1: 56.092,
    x2: -173.817,
    y2: 56.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#471f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#471f6c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M209.5,0c-.058,0-.115.082-.172.124a13.194,13.194,0,0,1,4.386,1.318A13.192,13.192,0,0,1,218.1.125C218.04.083,217.982,0,217.925,0Z",
    transform: "translate(-209.324 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6.931,
    y1: 17.571,
    x2: -6.898,
    y2: 17.571,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#784091"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M224.425,1.742a13.322,13.322,0,0,1,3.124,2.186A13.19,13.19,0,0,1,231.375,2.9,13.362,13.362,0,0,0,228.811.423a13.194,13.194,0,0,0-4.386,1.319",
    transform: "translate(-224.425 -0.423)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -9.38,
    y1: 7.192,
    x2: -9.339,
    y2: 7.192,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f2f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693d90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M235.181,9.979a13.347,13.347,0,0,1,2.166,2.631,13.2,13.2,0,0,1,3.271-1.046,13.3,13.3,0,0,0-1.612-2.613,13.19,13.19,0,0,0-3.825,1.028",
    transform: "translate(-235.181 -8.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -12.564,
    y1: 6.212,
    x2: -12.511,
    y2: 6.212,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#412481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2b86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M242.639,18.994a13.241,13.241,0,0,1,1.078,2.117l2.324-2.871c-.043-.1-.087-.194-.132-.291a13.2,13.2,0,0,0-3.271,1.046",
    transform: "translate(-242.639 -17.948)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -20.715,
    y1: 6.362,
    x2: -20.63,
    y2: 6.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312575"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M196.391,0l-.036.058s-.008.008-.013.008l-1.551,2.447h.155a13.444,13.444,0,0,1,1.5.086A13.359,13.359,0,0,1,198.995.137s.006,0,.008-.006.006-.006.009-.006c.057-.042.114-.124.172-.124Z",
    transform: "translate(-194.791 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -12.878,
    y1: 9.747,
    x2: -12.812,
    y2: 9.747,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332576"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M200.5,2.9a13.189,13.189,0,0,1,3.826,1.028,13.316,13.316,0,0,1,3.124-2.186A13.2,13.2,0,0,0,203.062.423,13.356,13.356,0,0,0,200.5,2.9",
    transform: "translate(-200.499 -0.423)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -8.38,
    y1: 7.192,
    x2: -8.338,
    y2: 7.192,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f2b86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2c86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M213.669,7.15a13.289,13.289,0,0,1,3.124,1.923,13.29,13.29,0,0,1,3.124-1.923,13.32,13.32,0,0,0-3.124-2.186,13.316,13.316,0,0,0-3.124,2.186",
    transform: "translate(-213.669 -4.964)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -9.933,
    y1: 5.814,
    x2: -9.886,
    y2: 5.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#472078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1f6b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M224.425,14.413a13.364,13.364,0,0,1,2.388,2.57,13.3,13.3,0,0,1,2.9-1.861,13.346,13.346,0,0,0-2.166-2.631,13.289,13.289,0,0,0-3.124,1.923",
    transform: "translate(-224.425 -12.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -12.322,
    y1: 4.831,
    x2: -12.267,
    y2: 4.831,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#572583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532180"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M232.645,23.409a13.229,13.229,0,0,1,1.647,3.139l2.334-2.883a13.241,13.241,0,0,0-1.078-2.117,13.3,13.3,0,0,0-2.9,1.861",
    transform: "translate(-232.645 -21.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -16.975,
    y1: 3.815,
    x2: -16.902,
    y2: 3.815,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a338a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c2d87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M192.1,8.662,191,10.4h0l.722.889c.141.021.283.043.423.068a13.3,13.3,0,0,1,1.612-2.614,13.444,13.444,0,0,0-1.5-.085c-.052,0-.1,0-.155,0",
    transform: "translate(-190.996 -8.659)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -20.099,
    y1: 8.453,
    x2: -19.993,
    y2: 8.453,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#954291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#943e90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M194.951,11.564a13.206,13.206,0,0,1,3.271,1.046,13.346,13.346,0,0,1,2.166-2.631,13.189,13.189,0,0,0-3.826-1.028,13.3,13.3,0,0,0-1.612,2.613",
    transform: "translate(-194.951 -8.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -10.415,
    y1: 6.212,
    x2: -10.362,
    y2: 6.212,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#693a8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3d8f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M206.211,15.121a13.3,13.3,0,0,1,2.9,1.861,13.375,13.375,0,0,1,2.388-2.57,13.29,13.29,0,0,0-3.124-1.923,13.346,13.346,0,0,0-2.166,2.631",
    transform: "translate(-206.211 -12.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -11.322,
    y1: 4.831,
    x2: -11.267,
    y2: 4.831,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#461d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421c5f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M216.2,21.68a13.352,13.352,0,0,1,2.388,2.628,13.36,13.36,0,0,1,2.388-2.628,13.364,13.364,0,0,0-2.388-2.57,13.374,13.374,0,0,0-2.388,2.57",
    transform: "translate(-216.204 -19.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -13.15,
    y1: 3.806,
    x2: -13.089,
    y2: 3.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23184d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f1951"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M224.425,30.584a13.239,13.239,0,0,1,1.689,3.408l2.345-2.9a13.231,13.231,0,0,0-1.647-3.139,13.36,13.36,0,0,0-2.388,2.628",
    transform: "translate(-224.425 -27.956)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -16.158,
    y1: 2.852,
    x2: -16.086,
    y2: 2.852,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#060930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1646"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M193.786,18.071c.043-.1.087-.194.132-.291-.14-.025-.281-.048-.423-.069Z",
    transform: "translate(-193.495 -17.711)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -132.894,
    y1: 56.092,
    x2: -132.207,
    y2: 56.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc599d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6539a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M194.5,18.239l2.324,2.871a13.216,13.216,0,0,1,1.078-2.117,13.206,13.206,0,0,0-3.271-1.046c-.045.1-.089.193-.132.291",
    transform: "translate(-194.498 -17.948)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -16.605,
    y1: 6.362,
    x2: -16.52,
    y2: 6.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#874f99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a549d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M202.5,23.665l2.334,2.883a13.24,13.24,0,0,1,1.646-3.139,13.3,13.3,0,0,0-2.9-1.861,13.216,13.216,0,0,0-1.078,2.117",
    transform: "translate(-202.5 -21.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -14.777,
    y1: 3.815,
    x2: -14.704,
    y2: 3.815,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3a8e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M210.536,31.095l2.345,2.9a13.238,13.238,0,0,1,1.689-3.408,13.352,13.352,0,0,0-2.388-2.628,13.241,13.241,0,0,0-1.646,3.139",
    transform: "translate(-210.536 -27.956)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -15.158,
    y1: 2.852,
    x2: -15.086,
    y2: 2.852,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a1f69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381f66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M218.609,40.41,220.3,42.5l1.689-2.087A13.237,13.237,0,0,0,220.3,37a13.237,13.237,0,0,0-1.689,3.408",
    transform: "translate(-218.609 -37.002)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -18.794,
    y1: 2.654,
    x2: -18.708,
    y2: 2.654,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#102152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131544"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M5.794,31.792H7.239a4.382,4.382,0,0,1,3.223.993q.972.993.972,3.682A7.267,7.267,0,0,1,11,39.4a2.562,2.562,0,0,1-1.2,1.27,6.558,6.558,0,0,1-2.583.364H5.794ZM0,27.959V44.881H8.608a14.79,14.79,0,0,0,3.453-.462,6.392,6.392,0,0,0,2.609-1.345,6.992,6.992,0,0,0,1.9-2.5,10.374,10.374,0,0,0,.684-4.207,11.442,11.442,0,0,0-.46-3.278,7.151,7.151,0,0,0-1.484-2.712,6.655,6.655,0,0,0-2.59-1.789,11.311,11.311,0,0,0-4.112-.624Z",
    transform: "translate(0 -27.959)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0,
    y1: 1.017,
    x2: 0.017,
    y2: 1.017,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 5.806,
    height: 16.922,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -3.761,
    y1: 1.017,
    x2: -3.711,
    y2: 1.017,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M117.648,32.345l2.07,6.083H115.6Zm-3.089-4.386-7.047,16.922h5.916l.914-2.793h6.578l.938,2.793h6.067l-7.045-16.922Z",
    transform: "translate(-107.512 -27.959)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1.53,
    y1: 1.017,
    x2: -1.516,
    y2: 1.017,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -13.96,
    y1: 1.017,
    x2: -13.91,
    y2: 1.017,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M318.435,27.63a5.483,5.483,0,0,0-2.52,1.824,4.136,4.136,0,0,0-.838,2.464,3.973,3.973,0,0,0,1.637,3.266,13.335,13.335,0,0,0,5.436,2.055,7.9,7.9,0,0,1,2.967.981,1.5,1.5,0,0,1,.64,1.177,1.524,1.524,0,0,1-.672,1.218,3.042,3.042,0,0,1-1.912.525,3.211,3.211,0,0,1-2.558-1.027,3.573,3.573,0,0,1-.729-1.847l-5.512.312a6.286,6.286,0,0,0,2.084,4.225q1.842,1.662,6.625,1.662a12.353,12.353,0,0,0,4.515-.71,6.139,6.139,0,0,0,2.788-2.084,5,5,0,0,0,1-3,4.408,4.408,0,0,0-.748-2.5,5.578,5.578,0,0,0-2.392-1.876A26.291,26.291,0,0,0,322.8,32.8a5.074,5.074,0,0,1-1.944-.623.916.916,0,0,1-.422-.727,1.147,1.147,0,0,1,.512-.941,2.5,2.5,0,0,1,1.522-.387,3.161,3.161,0,0,1,1.925.519,2.573,2.573,0,0,1,.914,1.662l5.461-.289a5.092,5.092,0,0,0-2.245-3.838,10.233,10.233,0,0,0-5.48-1.206,12.906,12.906,0,0,0-4.611.664",
    transform: "translate(-314.374 -26.966)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -5.368,
    y1: 1,
    x2: -5.351,
    y2: 1,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M382.945,27.959v4.179h5.909V44.88h5.794V32.137h5.909V27.959Z",
    transform: "translate(-382.945 -27.959)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -6.316,
    y1: 1.017,
    x2: -6.3,
    y2: 1.017,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M244.392,26.487v12.9h4.745V20.223Z",
    transform: "translate(-244.392 -20.223)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -14.961,
    y1: 1.015,
    x2: -14.9,
    y2: 1.015,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M188.122,40.331h4.745v-12.9l-4.745-5.88Z",
    transform: "translate(-188.122 -21.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -11.516,
    y1: 1.015,
    x2: -11.455,
    y2: 1.015,
    xlinkHref: "#linear-gradient-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682",
    transform: "translate(195 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520",
    transform: "translate(-125.596 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3158",
    "data-name": "Rectangle 3158",
    width: 4.394,
    height: 2.596,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522",
    transform: "translate(-122.86 -316.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3159",
    "data-name": "Rectangle 3159",
    width: 2.761,
    height: 2.698,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524",
    transform: "translate(-121.249 -313.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3160",
    "data-name": "Rectangle 3160",
    width: 0.423,
    height: 0.36,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(-134.197 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3525",
    "data-name": "Group 3525",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3161",
    "data-name": "Rectangle 3161",
    width: 8.773,
    height: 1.442,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528",
    transform: "translate(-129.81 -318.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3162",
    "data-name": "Rectangle 3162",
    width: 6.95,
    height: 3.505,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3530",
    "data-name": "Group 3530",
    transform: "translate(-126.686 -316.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3529",
    "data-name": "Group 3529",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3163",
    "data-name": "Rectangle 3163",
    width: 5.437,
    height: 3.659,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(-124.519 -313.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3164",
    "data-name": "Rectangle 3164",
    width: 3.402,
    height: 3.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3534",
    "data-name": "Group 3534",
    transform: "translate(-138.418 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3165",
    "data-name": "Rectangle 3165",
    width: 4.394,
    height: 2.599,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536",
    transform: "translate(-136.76 -318.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    "data-name": "Group 3535",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3166",
    "data-name": "Rectangle 3166",
    width: 6.95,
    height: 3.505,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538",
    transform: "translate(-132.934 -317.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3167",
    "data-name": "Rectangle 3167",
    width: 6.249,
    height: 4.109,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3540",
    "data-name": "Group 3540",
    transform: "translate(-129.81 -315.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 5.291,
    height: 4.492,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3542",
    "data-name": "Group 3542",
    transform: "translate(-127.422 -312.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3541",
    "data-name": "Group 3541",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3169",
    "data-name": "Rectangle 3169",
    width: 3.981,
    height: 5,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3544",
    "data-name": "Group 3544",
    transform: "translate(-139.52 -316.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3543",
    "data-name": "Group 3543",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3170",
    "data-name": "Rectangle 3170",
    width: 2.76,
    height: 2.699,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546",
    transform: "translate(-138.372 -316.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3171",
    "data-name": "Rectangle 3171",
    width: 5.437,
    height: 3.659,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548",
    transform: "translate(-135.101 -315.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3172",
    "data-name": "Rectangle 3172",
    width: 5.291,
    height: 4.492,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550",
    transform: "translate(-132.198 -313.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3173",
    "data-name": "Rectangle 3173",
    width: 4.776,
    height: 5.197,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552",
    transform: "translate(-129.81 -310.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3174",
    "data-name": "Rectangle 3174",
    width: 4.034,
    height: 6.036,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(-138.794 -313.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3175",
    "data-name": "Rectangle 3175",
    width: 0.423,
    height: 0.36,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(-138.503 -313.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3176",
    "data-name": "Rectangle 3176",
    width: 3.402,
    height: 3.162,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558",
    transform: "translate(-136.179 -312.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3177",
    "data-name": "Rectangle 3177",
    width: 3.981,
    height: 5,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(-133.844 -310.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3178",
    "data-name": "Rectangle 3178",
    width: 4.034,
    height: 6.036,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562",
    transform: "translate(-131.499 -308.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 3.379,
    height: 5.495,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    "data-name": "Group 3564",
    transform: "translate(-195 -310.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3563",
    "data-name": "Group 3563",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3180",
    "data-name": "Rectangle 3180",
    width: 17.253,
    height: 16.922,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-23)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566",
    transform: "translate(-173.163 -310.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 5.806,
    height: 16.922,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568",
    transform: "translate(-163.77 -310.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 20.412,
    height: 16.922,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570",
    transform: "translate(-113.945 -310.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3184",
    "data-name": "Rectangle 3184",
    width: 5.806,
    height: 16.922,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(-103.682 -311.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3186",
    "data-name": "Rectangle 3186",
    width: 17.01,
    height: 17.499,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(-83.764 -310.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3187",
    "data-name": "Rectangle 3187",
    width: 17.611,
    height: 16.922,
    fill: "url(#linear-gradient-28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576",
    transform: "translate(-124.01 -313.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3188",
    "data-name": "Rectangle 3188",
    width: 4.745,
    height: 19.169,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578",
    transform: "translate(-140.355 -312.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3189",
    "data-name": "Rectangle 3189",
    width: 4.745,
    height: 18.784,
    fill: "url(#linear-gradient-30)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamistLogo);
export default __webpack_public_path__ + "static/media/diamist_logo.ce5eddfbaec37c3fa3754591f7d15de6.svg";
export { ForwardRef as ReactComponent };